
angular.module('bmsApp.employeeAttendanceRecord', []);
